import { CategoryWithArtistsType } from '@api';
import {
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { Artists } from './components';

type ArtistRosterTableRowPropsType = {
  categoryWithArtists: CategoryWithArtistsType;
};

export const ArtistRosterTableRow: React.FC<ArtistRosterTableRowPropsType> = ({
  categoryWithArtists,
}) => {
  const { t } = useTranslation('personDetailsGeneral');

  const label = t(`COMPANY_LINKS.CATEGORIES.${categoryWithArtists.category}`, {
    ns: 'common',
  });
  const value = <Artists artists={categoryWithArtists.artists} />;

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{value}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
